// extracted by mini-css-extract-plugin
export default {"custom_tooltip":"tooltip_custom_tooltip__n57Hh","tooltip_text":"tooltip_tooltip_text__AR8x6"};